import React from "react";
import { QuickFactList, QuickFact, IconWrapper } from "./quick-fact.styled";
import { HeroFormSliceFragment } from "../../types/graphql";
import { PrismicRichText } from "@prismicio/react";
import { htmlSerializer } from "../../utils/htmlSerializer";
import * as FA from "../../styles/fontawesome";

interface QuickFactProps extends React.ComponentProps<"div"> {
  quickFacts: HeroFormSliceFragment["items"];
}

const QuickFacts = (props: QuickFactProps) => {
  return (
    <QuickFactList className={props.className}>
      {props.quickFacts.map((quickFact, index) => {
        let iconStyle = FA.ShieldCheckRegular;
        if (quickFact) {
          switch (quickFact.quick_fact_icon) {
            case "Calendar":
              iconStyle = FA.CalendarDayRegular;
              break;
            case "Shield":
              iconStyle = FA.ShieldCheckRegular;
              break;
            case "Building":
              iconStyle = FA.IndustryWindowsRegular;
              break;
            case "File Certificate":
              iconStyle = FA.FileCertificateRegular;
              break;
            case "Piggy Bank":
              iconStyle = FA.PiggyBankRegular;
              break;
            case "Credit Card":
              iconStyle = FA.CreditCardRegular;
              break;
            case "Money Bill Wave":
              iconStyle = FA.MoneyBillWaveRegular;
              break;
            case "Line Chart":
              iconStyle = FA.ChartLineRegular;
              break;
            case "Check Mark":
              iconStyle = FA.CheckRegular;
              break;
          }
        }
        return (
          <QuickFact key={index}>
            <span>
              {quickFact?.quick_fact_icon && (
                <IconWrapper>
                  <i css={iconStyle} />
                </IconWrapper>
              )}
            </span>
            {quickFact?.quick_fact_text && (
              <span>
                <PrismicRichText
                  field={quickFact.quick_fact_text.richText}
                  components={htmlSerializer}
                />
              </span>
            )}
          </QuickFact>
        );
      })}
    </QuickFactList>
  );
};

export default QuickFacts;
